export const UPDATE_MANIFEST_REQUEST = "UPDATE_MANIFEST_REQUEST";
export const UPDATE_MANIFEST_SUCCESS = "UPDATE_MANIFEST_SUCCESS";
